export const defaultNftImageUrl =
  'https://blockem.s3.us-east-2.amazonaws.com/nft-default-photo.png';

export const blockemLinkShareImageUrl =
  'https://blockem.s3.us-east-2.amazonaws.com/LinkShare.png';
